import { render } from "./BoxButton.vue?vue&type=template&id=272c3950&scoped=true"
import script from "./BoxButton.vue?vue&type=script&lang=js"
export * from "./BoxButton.vue?vue&type=script&lang=js"

import "./BoxButton.vue?vue&type=style&index=0&id=272c3950&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272c3950"]])

export default __exports__